<template>
  <div class="position-relative">
    <div class="main-body">
      <div class="main-sidebar p-3 shadow-sm bg-white">
        <a href="javascript:void(0)" @click="$router.push('/docs/')" class="pb-1">Getting Started</a>
        <router-link
          v-for="(item, index) in components" :key="index"
          :to="item.link"
          class="py-1"
        >
          {{ item.name }}
        </router-link>
      </div>
      <perfect-scrollbar>
        <RouterView />
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

export default {
  components: { PerfectScrollbar },
  data () {
    return {
      components: [
        { name: 'Button', link: 'button' },
        { name: 'Category Filter', link: 'categoryfilter' },
        { name: 'Checkbox', link: 'checkbox' },
        { name: 'Datepicker', link: 'datepicker' },
        { name: 'Dialog', link: 'dialog' },
        { name: 'Input', link: 'input' },
        { name: 'Love Languages', link: 'lovelanguages' },
        { name: 'Member Stack', link: 'memberstack' },
        { name: 'Multi Select', link: 'multi-select' },
        { name: 'Popup Dialogs', link: 'popup-dialogs' },
        { name: 'Productivity Level', link: 'productivitylevel' },
        { name: 'Radio', link: 'radio' },
        { name: 'Range Slider', link: 'range-slider' },
        { name: 'Search Bar', link: 'searchbar' },
        { name: 'Select', link: 'select' },
        { name: 'Sort Select', link: 'sortselect' },
        { name: 'Splash Message', link: 'splash-message' },
        { name: 'Status Badge', link: 'status-badge' },
        { name: 'Table', link: 'table' },
        { name: 'Tabs', link: 'tabs' },
        { name: 'Toggle', link: 'toggle' },
        { name: 'Range Slider', link: 'rangeslider' },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.main-body {
  display: flex;
  .main-sidebar {
    display: flex;
    flex-direction: column;
    min-width: 300px;
    height: calc(100vh - 60px);
    a {
      opacity: .75;
      font-size: .9375rem !important;
      color: var(--secondary) !important;
      &:hover {
        opacity: 1;
      }
    }
    .router-link-active {
      color: var(--primary) !important;
      opacity: 1;
    }
  }
  .main-content {
    background-color: var(--white);
  }
}

.ps {
  height: calc(100vh - 60px);
  width: 100%;
}
</style>